import React from "react";

const LoaderSpinner = () => {
  return (
    <div className="loader-section">
      <div className="loader"></div>
    </div>
  );
};

export default LoaderSpinner;
